import common from './common/main'
export default {
  common
}
